import EmpleoApi from "./../../api/Empresa/EmpleoApi";
import { message } from "antd";

export default {
    createEmpleo: async (data) => {
        const response = await EmpleoApi.createEmpleo(data);
        if (response?.success) {
            message.success(response.message);
        } else {
            message.error(response.message);
        }
        return response;
    },
    editEmpleo: async (data) => {
        const response = await EmpleoApi.editEmpleo(data);
        if (response?.success) {
            message.success(response.message);
        } else {
            message.error(response.message);
        }
        return response;
    },
    getEmpleosMe: async () => {
        const response = await EmpleoApi.getEmpleosMe();
        if (!response?.success) {
            response.data = [];
            message.error(response.message);
        }
        return response;
    },
    deleteEmpleoMe: async (id) => {
        const response = await EmpleoApi.deleteEmpleoMe(id);
        if (response?.success) {
            message.success(response.message);
        } else {
            message.error(response.message);
        }
        return response;
    },
    cambiarEstatusDePostulacion: async (data) => {
        const response = await EmpleoApi.cambiarEstatusDePostulacion(data);
        if (response?.success) {
            message.success(response.message);
        }else{
            message.error(response.message);
        }
        return response;
    },
    // Sólo para egresados
    getEmpleosNoAplicadosByEgredado: async () => {
        const response = await EmpleoApi.getEmpleosNoAplicadosByEgredado();
        if (!response?.success) {
            response.data = [];
            message.error(response.message);
        }
        return response;
    },
    postularEgresadoAEmpleo: async (id_empleo) => {
        const response = await EmpleoApi.postularEgresadoAEmpleo(id_empleo);
        if (response?.success) {
            message.success(response.message);
        } else {
            message.error(response.message);
        }
        return response;
    },
    getPostulacionesByEmpleo: async (id_empleo) => {
        const response = await EmpleoApi.getPostulacionesByEmpleo(id_empleo);
        if (!response?.success) {
            response.data = [];
            message.error(response.message);
        }
        return response;
    },
}